import React, { useMemo, useEffect } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Row,
  Col,
  Card,
  Radio
} from '@lockerpm/design';

import common from "../../../../../utils/common";

const PlanReview = (props) => {
  const { t } = useTranslation();

  const {
    className = '',
    planTypes = {},
    planPeriod = {},
    selectedPlan = {},
    selectedPeriod = {},
    onSwitchPlan = () => { },
    setSelectedPlanDuration = () => { }
  } = props;

  const plans = useSelector((state) => state.resource.plans);

  const discountPercentage = (planInfo) => {
    const fullPrice = planInfo.price.usd * 12
    const discount = fullPrice - planInfo.yearly_price.usd
    const percentage = (discount * 100) / fullPrice
    if (!Number.isNaN(percentage)) {
      return Math.ceil(percentage)
    }
    return 0
  }

  const allPlans = useMemo(() => {
    const res = []
    plans.forEach(p => {
      if (p.alias === planTypes.FREE) {
        return
      }
      res.push({
        ...p,
        duration: planPeriod.MONTHLY,
        monthCount: 1
      })
      res.push({
        ...p,
        duration: planPeriod.YEARLY,
        monthCount: 12,
        saved: discountPercentage(p),
        popular: p.alias === planTypes.PREMIUM
      })
    })
    return res
  }, [plans])

  useEffect(() => {
    if (!selectedPlan?.name && allPlans.length > 0) {
      const planInfo = allPlans[0]
      setSelectedPlanDuration(planInfo);
      onSwitchPlan(planInfo, true)
    }
  }, [allPlans])

  const handleChangePlan = (planInfo) => {
    setSelectedPlanDuration(planInfo.duration)
    onSwitchPlan(planInfo, true)
  }

  return (
    <div className={className}>
      <Row gutter={[12, 12]}>
        {
          allPlans.map((planInfo, index) => <Col
            xl={6}
            lg={12}
            md={12}
            sm={12}
            xs={24}
            key={index}
          >
            <Card
              bodyStyle={{ padding: 0 }}
              className={`rounded hover:border-primary p-6 text-center cursor-pointer ${
                planInfo.alias === selectedPlan.alias && planInfo.duration === selectedPeriod.duration ? 'bg-[#F0FAF1]' : ''
              }`}
              onClick={() => handleChangePlan(planInfo)}
            >
              <div className="text-left">
                <Radio
                  checked={planInfo.alias === selectedPlan.alias && planInfo.duration === selectedPeriod.duration}
                />
              </div>
              <div className="h-6 -ml-6 mb-2 mt-3">
                {
                  planInfo.popular && <div
                    className="gradient-bg rounded-r-full h-full flex items-center justify-center"
                  >
                    <p className="text-white font-semibold text-[10px]">
                      {t('manage_plans.most_popular').toUpperCase()}
                    </p>
                  </div>
                }
              </div>

              <p className="font-semibold mb-1 text-[16px]">
                {planInfo.name}
              </p>
              <p>
                {planInfo.monthCount > 1 ? t('common.months', { count: planInfo.monthCount }) : t('common.a_month')}
              </p>

              <div className="h-[30px] my-2">
                {
                  planInfo.saved && <div
                    className="flex items-center justify-center rounded-full bg-warning"
                  >
                    <p className="font-semibold text-white">
                      {t('manage_plans.save')} {planInfo.saved}%
                    </p>
                  </div>
                }
              </div>

              <p className="text-head-3 font-semibold text-primary mb-3">
                {common.formatCurrency(planInfo.duration === planPeriod.YEARLY ? planInfo.yearly_price.usd : planInfo.price.usd, 2, '$')}
              </p>

              <p>
                {common.formatCurrency(planInfo.duration === planPeriod.YEARLY ? planInfo.yearly_price.usd/12 : planInfo.price.usd, 2, '$')} / mo / {t('plans.members', {count: planInfo.max_number, s: planInfo.max_number <= 1 ? '' : 's'})}
              </p>
            </Card>
          </Col>)
        }
      </Row>
    </div>
  );
}

export default PlanReview;